var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41302 4.0417C5.41636 4.03965 5.41971 4.0376 5.42305 4.03555L7.13399 5.7465C7.13057 5.74846 7.12715 5.75044 7.12373 5.75241L8.24952 6.8782C8.25351 6.87679 8.2575 6.87539 8.2615 6.874L11.126 9.7385C11.1246 9.7425 11.1232 9.74649 11.1218 9.75048L12.2476 10.8763C12.2496 10.8728 12.2515 10.8694 12.2535 10.866L14.1236 12.7361C14.1209 12.7388 14.1182 12.7415 14.1155 12.7442L14.6673 13.2959C14.9602 13.5888 14.9602 14.0637 14.6673 14.3566C14.3744 14.6495 13.8995 14.6495 13.6066 14.3566L12.9625 13.7125C11.7824 14.534 10.4332 15 9 15C5.71938 15 2.87864 12.5582 1.5 9C2.12898 7.37662 3.0623 5.98562 4.20288 4.95288L3.53033 4.28033C3.23744 3.98744 3.23744 3.51256 3.53033 3.21967C3.82322 2.92678 4.2981 2.92678 4.59099 3.21967L5.41302 4.0417ZM5.99984 6.74984C5.52901 7.37662 5.25 8.15573 5.25 9C5.25 11.0711 6.92893 12.75 9 12.75C9.84427 12.75 10.6234 12.471 11.2502 12.0002L10.1714 10.9214C9.83019 11.1299 9.42912 11.25 9 11.25C7.75736 11.25 6.75 10.2426 6.75 9C6.75 8.57088 6.87013 8.16981 7.0786 7.8286L5.99984 6.74984Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9C12.75 9.07859 12.7476 9.15661 12.7428 9.234L15.0993 11.5905C15.6578 10.8238 16.1312 9.95185 16.5 9C15.1214 5.44177 12.2806 3 9 3C8.262 3 7.54627 3.12357 6.86443 3.35561L8.766 5.25718C8.84339 5.25242 8.92141 5.25 9 5.25C11.0711 5.25 12.75 6.92893 12.75 9Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/EyeClosed.32cea370f9b259380c314f19ddb2b942.svg";
export { ForwardRef as ReactComponent };